import React, { useState } from 'react';
import { Box, Typography, TextField, Button, Card, CardContent, CircularProgress, Alert } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const PublicProfiles: React.FC = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSearch = async () => {
    if (!searchQuery.trim()) {
      return;
    }
    
    setLoading(true);
    setError(null);
    
    try {
      // Navigate to the specific public profile
      navigate(`/profile/${searchQuery.trim()}`);
    } catch (err: any) {
      console.error('Failed to search profile:', err);
      setError('Profile search failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 800, margin: 'auto', mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        Public Profiles
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        Search for Qixit users by their alias name to view their public profiles.
      </Typography>

      <Card sx={{ mb: 4 }}>
        <CardContent>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
              fullWidth
              label="Search by Alias Name"
              placeholder="e.g., beta01_public"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  handleSearch();
                }
              }}
              disabled={loading}
            />
            <Button
              variant="contained"
              onClick={handleSearch}
              disabled={loading || !searchQuery.trim()}
              startIcon={loading ? <CircularProgress size={20} /> : <SearchIcon />}
            >
              Search
            </Button>
          </Box>
          
          {error && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {error}
            </Alert>
          )}
        </CardContent>
      </Card>

      <Typography variant="h6" gutterBottom>
        Popular Public Profiles
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Coming soon: Browse trending and popular Qixit profiles
      </Typography>
    </Box>
  );
};

export default PublicProfiles;

